import React, { useState, useEffect } from "react";
import useGlobal from "store";
import PanelHeader from "components/PanelHeader/PanelHeader";
import { Row, Col, Card, CardHeader, CardTitle, CardBody, FormGroup, Input, Button } from "reactstrap";
import BudgetRow from "./BudgetRow";
import GlobalBudget from "./GlobalBudget";

const SpendingControls = (props) => {

    const [state, actions] = useGlobal(
      state => state,
      actions => actions
    );

    useEffect(() => {
      if(!state.user) {
        return
      }
    }, [state.user])

    
    const [budgetFormState, setContentFormState] = useState({
      domain: '',
      budget: '',
    });

    const handleContentFormInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formFields = { ...budgetFormState };
        formFields[name] = value;
        setContentFormState(formFields);
    }

    const handleMonthlyBudgetInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formFields = { ...budgetFormState };
        formFields[name] = value.match(/[0-9]*\.?[0-9]*/g) ? value.match(/[0-9]*\.?[0-9]*/g)[0] : "";
        setContentFormState(formFields);
    }

    const createUserBudget = () => {
      let formData = { ...budgetFormState };
      console.log('create pricing rule', formData);
      actions.userActions.createUserBudget(formData);
      actions.notifierActions.notify('New Budget Created', 'success', 'br');
    }

    const deleteBudget = (budgetId) => {
      console.log('delete budget', budgetId);
      actions.userActions.removeUserBudget(budgetId);
      actions.notifierActions.notify('Budget Removed', 'success', 'br');
    }

    const budgets = state.budgets.map(budget => <BudgetRow key={budget.id} removeHandler={deleteBudget} {...budget}></BudgetRow>);

    return (
        <>
        <PanelHeader size="sm" />
        <div className="content">
          
          {state.user ?
          <>
            <Row>
                <Col md="6">
                    <GlobalBudget userId={state.user.id} monthlyBudget={state.user.monthly_budget}></GlobalBudget>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h4">Set monthly limits for specific sites</CardTitle>
                            <p>Receive a notification when you spend a certain amount for a specific site in a given month. Just enter the URL for the site and set at what monthly spend you want to be notified.</p>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                    <label>Domain (example.com)</label>
                                        <Input type="select" name="domain" onChange={handleContentFormInputChange} value={budgetFormState.domain}>
                                            <option>thestreet.com</option>
                                        </Input>
                                        
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                    <label>Monthly Budget</label>
                                        <Input type="text" placeholder="Monthly" name="budget" onChange={handleMonthlyBudgetInputChange} value={budgetFormState.budget} />
                                    </FormGroup>
                                </Col>
                                
                                <Col md="2">
                                    <FormGroup>
                                        <label>&nbsp;</label><br/>
                                        <Button onClick={() => createUserBudget()} color="primary" style={{margin: "0px"}}>Add Budget</Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr/>
                            <Row>
                            <Col md="12">
                                {budgets.length === 0 ? <p>No Additional Spending Notifications.</p> : <></> }
                                {budgets}
                            </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            </> : <></> }
        </div>
        
        </>
    );
}

export default SpendingControls;